module.exports = __webpack_public_path__ + "img/logo.f955722a.png";